import { useRef } from 'react'
import { useDelayTimer } from 'tyan/public/hooks'

export * from '../../../utility/fieldListFn.js'

export const handleValueChange = (name, initValue, onChange, type) => (field, inputValue) => {
	onChange({ name, newValue: inputValue, type })
}

import lazyRenderField from './lazyRenderField'

import renderAutoComplete from './renderAutoComplete'
import renderBorder from './renderBorder'
import renderButtons from './renderButtons'
import renderCheckBox from './renderCheckBox'
import renderCheckBoxSingle from './renderCheckBoxSingle'
import renderCheckGrid from './renderCheckGrid'
import renderDate from './renderDate'
import renderDateTime from './renderDateTime'
import renderFiles from './renderFiles'
import renderFlowLog from './renderFlowLog'
import renderGrid from './renderGrid'
import renderGroup from './renderGroup'
import renderHtml from './renderHtml'
import renderIFrame from './renderIFrame'
import renderLabel from './renderLabel'
import renderLineProcessing from './renderLineProcessing'
import renderLineProcessing2 from './renderLineProcessing2'
import renderMonth from './renderMonth'
import renderMultiSelect from './renderMultiSelect.js'
import renderNeed2Know from './renderNeed2Know'
import renderNumber from './renderNumber'
import renderRadio from './renderRadio'
import renderSegmentedButton from './renderSegmentedButton'
import renderSelect from './renderSelect'
import renderText from './renderText'
import renderTreeGrid from './renderTreeGrid'
import renderVirtualGroup from './renderVirtualGroup'

const renderSwitch = {
	// _selfdefine: (fieldPar, onChange, initValues, changedValues, defaultStyle) => {
	//   const { comp: Comp, ...field } = fieldPar
	//   return !Comp || field.cdt && !field.cdt() ? null : <Comp {...getMixedProps('_selfdefine', [defaultStyle, field]).props} initValues={initValues} changedValues={changedValues} /* onChange={handleValueChange(field.name, initValues[field.name], onChange, 'number')} */ />
	// },
	_autoComplete: renderAutoComplete,
	_border: renderBorder,
	_buttons: renderButtons,
	_checkbox: renderCheckBox,
	_checkboxSingle: renderCheckBoxSingle,
	_checkgrid: renderCheckGrid,
	_date: renderDate,
	_datetime: renderDateTime,
	_files: renderFiles,
	_float: renderNumber,
	_flowLog: renderFlowLog,
	_grid: renderGrid,
	_group: renderGroup,
	_html: renderHtml,
	_iframe: renderIFrame,
	_int: renderNumber,
	_label: renderLabel,
	_lineProcessing: renderLineProcessing,
	_lineProcessing2: renderLineProcessing2,
	_month: renderMonth,
	_multiSelect: renderMultiSelect,
	_need2know: renderNeed2Know,
	_number: renderNumber,
	_radio: renderRadio,
	_segmentedButton: renderSegmentedButton,
	_select: renderSelect,
	_text: renderText,
	_treegrid: renderTreeGrid,
	_virtualGroup: renderVirtualGroup,
}

Object.entries({
	_captcha: () => import(/* webpackChunkName: 'chunks/public/fb/cap' */ './renderCaptcha'),
	_chart: () => import(/* webpackChunkName: 'chunks/public/fb/dataVisual' */ './renderChart'),
	_circularGauge: () => import(/* webpackChunkName: 'chunks/public/fb/dataVisual' */ './renderCircularGauge'),
	_diagram: () => import(/*webpackChunkName: 'chunks/public/fb/diagram' */ './renderDiagram'),
	_gantt: () => import(/*webpackChunkName: 'chunks/public/fb/gantt' */ './renderGantt'),
	// _files: () => import(/* webpackChunkName: 'chunks/public/fb/files' */ './renderFiles'),
	_livescan: () => import(/* webpackChunkName: 'chunks/public/fb/lscan' */ './renderLiveScan'),
	// _checkbox: () => import(/* webpackChunkName: 'chunks/public/fb/cbox' */ './renderCheckBox'),
	_pdf: () => import(/*webpackChunkName: 'chunks/public/fb/pdf' */ './renderPdf'),
	_pdfStamp: () => import(/*webpackChunkName: 'chunks/public/fb/pdf' */ './renderPdfStamp'),
	_resourceCalendar: () => import(/*webpackChunkName: 'chunks/public/fb/resourceCalendar' */ './renderResourceCalendar'),
	_scan: () => import(/* webpackChunkName: 'chunks/public/fb/scan' */ './renderScan'),
	_schedule: () => import(/*webpackChunkName: 'chunks/public/fb/schedule' */ './renderSchedule'),
	_signature: () => import(/*webpackChunkName: 'chunks/public/fb/signature' */ './renderSignature'),
	_spreadsheet: () => import(/*webpackChunkName: 'chunks/public/fb/spreadsheet' */ './renderSpreadsheet'),
	_treegridselect: () => import(/*webpackChunkName: 'chunks/public/fb/treegridselect' */ './renderTreeGridSelect'),
	_treeselect: () => import(/*webpackChunkName: 'chunks/public/fb/treeselect' */ './renderTreeSelect'),
	_treeselect2: () => import(/*webpackChunkName: 'chunks/public/fb/treeselect2' */ './renderTreeSelect2')
}).forEach(([n, v]) => {
	renderSwitch[n] = lazyRenderField(n, v)
})
const fieldTypes = Object.keys(renderSwitch)
const listTypes = ['_files', '_grid', '_gantt'/* , '_checkgrid', '_treegrid', */]
const inputTypes = [
	'_autoComplete', '_captcha', '_checkbox', '_checkboxSingle', '_date', '_datetime', '_float',
	'_int', '_livescan',
	'_month', '_multiSelect',
	'_need2know', '_number',
	'_select', '_radio', '_scan', '_text',
	'_segmentedButton', '_signature', '_spreadsheet', '_treegridselect', '_treeselect', '_treeselect2',
	'_pdf', '_pdfStamp'
]
const requirableTypes = inputTypes.concat(listTypes)
const groupTypes = ['_group', '_border', '_virtualGroup']
const noDataTypes = ['_label', '_buttons']
// const noEncloserTypes = ['_checkgrid', '_treegrid'].concat(listTypes).concat(groupTypes)
const noEncloserTypes = [
	'_border', '_buttons',/*  '_chart',  */'_checkgrid', '_diagram',
	'_flowLog', '_gantt', '_grid', '_group', '_iframe',
	'_pdf', '_pdfStamp', '_resourceCalendar', '_schedule', '_segmentedButton', '_spreadsheet',
	'_treegrid', '_treegridselect', '_virtualGroup'
]
// ['Item', 'grid', 'button']
// labelNeededTypes: 需要label的组件类型，主要用于非继承自ContainerField的组件，如直接组件及Syncfusion的组件等
const labelNeededTypes = [
	'_autoComplete', '_date', '_datetime', '_month', '_lineProcessing2',
	'_multiSelect', '_signature', '_text', '_treeselect2'
]

const getFieldType = field => fieldTypes.find(o => field[o] !== undefined)
export { renderSwitch, /* fieldTypes,  */getFieldType, listTypes, inputTypes, requirableTypes, groupTypes, noDataTypes, noEncloserTypes, labelNeededTypes }

const disabled = false, flex = 1, key = null,
	label = '', labelWidth = 'auto', labelMinWidth = '8em', labelTextAlign = 'left', labelAlign = 'left',
	minWidth = Ext.os.is.Phone ? 200 : 380, maxWidth = null, margin = '5px 20px 5px 20px',
	placeholder = ' ', value = null, errorTarget = 'side', initHeight = 300

const fldCommProps = {
	ui: null, disabled, flex, key, label, labelAlign, labelTextAlign, labelWidth, labelMinWidth, minWidth, maxWidth, margin, prompt: null,
	required: false, clearable: true, editable: true, noLocale: false, hidden: false, placeholder, tooltip: '', minHeight: null, docked: ''
}

/**
 * 通用参数：
 * transFn: 数据转换函数
 * fieldset: string, 为字符串(含'')时有效，指定该组件的数据fieldset，如fieldset = 'XXX', 则该组件的值将会在initValuesXXX, changedValuesXXX中；未定义则取页面配置中的fieldset的name.
 * list: { listName: '样品', id: o }}表示是list中一个数据，
 * onChange(newChangedValue, { oldValue, id: list && list.id })):
 * cdt
 */
const defaultStyles = {
	_autoComplete: {
		...fldCommProps, value,
		callback: undefined,		// 回调函数，参数为函数(用于回传新备选数据，参数内容为字符串数组)；如有此配置，以下配置无效
		event: undefined, params: undefined,		// 用于向后台取数据的event，以及发送到后台的参数(对象)，后台返回为:{data:[]}
		editable: undefined,
		noLocale: undefined,
		showPopupButton: false,		// 是否显示弹出按钮
	},
	_border: {
		...fldCommProps,
		labelTextAlign: undefined, labelWidth: undefined, labelMinWidth: undefined, prompt: undefined, required: undefined, clearable: undefined, editable: undefined,
		minWidth: null, margin: '0px 0px 0px 20px', labelAlign: { top: 7, left: 6, right: 6 },
		padding: null, layout: null, borderStyle: { border: '1px solid #e1e1e1' }, height: null,
		initHeight, buttons: null,
		/* scrollable: false,  */delay: false,
		contextmenu: null
	},
	_button: {
		disabled, ui: null, noLocale: false, margin: '0px 20px 0px 0px', handler: null, docked: '', hidden: false, tooltip: '', style: {},
		contextmenu: null
	},
	_buttons: {
		...fldCommProps,
		key, margin: null, padding: margin, width: '100%',
		layout: { type: 'hbox', pack: 'start', align: 'center', wrap: true },
		top: null, right: null, bottom: null, left: null,
		items: null, // 形始{_button:'测试', ...} 的对象数据(老的代码会继续使用_buttons来配置)
		flex: null, minWidth: null, maxWidth: null
	},
	_captcha: { ...fldCommProps, value, },
	_chart: {
		minWidth, maxWidth, width: null, flex, height: null,
		padding: null, margin, aspectRatio: '2/1',
		type: 'chart', data: null
	},
	_circularGauge: {
		minWidth, maxWidth, width: null, flex,
		padding: null, margin, aspectRatio: '1/1',
		data: null
	},
	_checkbox: { ...fldCommProps, layout: { type: 'hbox', pack: 'start', wrap: true }, errorTarget },
	_checkboxItem: {
		disabled, flex: 0, key, labelAlign, labelTextAlign: 'left', bodyAlign: 'start', boxLabelAlign: 'after',
		itemNoLocale: true, itemMargin: '0px 10px 0px 0px', itemMinWidth: 200
	},
	_checkboxSingle: {
		...fldCommProps, bodyAlign: 'start', boxLabelAlign: 'after', boxLabel: null, checkedValue: '是', uncheckedValue: null,
		labelNoLocale: false, // 默认翻译label
		noLocale: true, // 默认不翻译内容
	},
	_checkgrid: {
		minWidth, maxWidth, width: '100%', flex, padding: '5px 0px 5px 20px', layout: { type: 'hbox', pack: 'start', wrap: true }, margin, default: null,
		selectableField: null,
		ignore: []		// 需排除的id
	},
	_date: {
		...fldCommProps, editable: undefined, noLocale: undefined,
		minDate: null, maxDate: null, min: null, max: null, openOnFocus: true
	},	// min, max 覆盖 minDate, maxDate
	_datetime: {
		...fldCommProps, editable: undefined, noLocale: undefined,
		minDate: null, maxDate: null, min: null, max: null,
		// minTime:null, maxTime:null,	// 时间范围，minTime、maxTime为字符串，格式为HH:mm:ss，可缩减为HH:mm或HH
		step: 30, 	// 时间步长，单位为分钟，默认30分钟
		unit: null, // 选择的单位，S:秒，M:分钟，H:小时，默认为null，表示为M
	}, // min, max 覆盖 minDate, maxDate
	_diagram: { minWidth, maxWidth, width: '100%', flex, padding: '5px 0px 5px 20px', layout: { type: 'hbox', pack: 'start', wrap: true }, margin, height: null },
	_files: {
		...fldCommProps, multiple: true, limit: 0, accept: null, imageSize: null, sortField: null,
		disableDelete: false, disableRename: false, disableUpload: false, disableEdit: true, onChange: null,
		disableDownload: false, 	// 禁止下载
		enableCapture: false,
		enableJoyusingV1: null,
		editNewImage: false, unacceptableFiles: null, maxSize: null,
		expansion: null,		// 扩展字段
		editFields: null,		// 自定义可编辑字段，有此配置则expansion以及原来的文件名、排序字段都不显示，但sortField配置依然需要以正确排序，如下为当前通用的文件名、排序字段配置
		// editFields: [
		// 	{ _text: '文件名称', name: 'FileName', prompt: '不可包含字符 \\/:*?"<>|' },
		// 	{ _int: '排序', name: sortField, textAlign: 'left', /* minWidth: '200px', maxWidth: '200px' */ }
		// ],
		rotatable: false,		// 允许旋转，只针对图片类附件有效
		showUploadPerson: false,	// 显示上传人员
		showUploadTime: false,		// 显示上传时间
		downloadAll: null,		// 下载全部文件的文件名, 不含.zip
		layout: null,			// 只用于图片呈现的情况
		param: null, // 上传文件的参数
	},
	_float: {
		...fldCommProps, value, decimals: 2, minValue: null, maxValue: null, stepValue: null, cycle: false,
		textAlign: 'right', trim: false, clearable: false, thousandsSeperator: true
	},
	_flowLog: {
		minWidth, maxWidth, /* width: '100%',  */flex, padding: '5px 0px 5px 20px', layout: { type: 'hbox', pack: 'start', wrap: true },
		margin, height: null, value, // pnlProps
	},
	// _html: { flex, key, label, labelAlign, labelTextAlign, labelWidth, minWidth, maxWidth, margin, prompt: null, required: false, value, padding: '5px 0px 5px 0px' },
	_html: {
		...fldCommProps, value, style: {}, padding: '6px 0px 4px 0px',
		contentNoLocale: true,	// 是否不翻译内容
		doTrans: false		// 传入内容翻译回调函数，参数为字符串，返回翻译后的字符串
	},
	_iframe: { ...fldCommProps, value, padding: '6px 0px 4px 0px' },
	_gantt: {
		minWidth, maxWidth, width: '100%', flex, padding: '5px 0px 5px 20px',
		layout: { type: 'hbox', pack: 'start', wrap: true },
		margin, height: null
	},
	_grid: {
		minWidth, maxWidth, width: '100%', flex, padding: '5px 0px 5px 20px', layout: { type: 'hbox', pack: 'start', wrap: true },
		margin, height: null,
		autoScroll: null, /* {stamp:'a'(用于指示重新开始), inter:3000(间隔时间), repeat:true(是否循环), cb:fn(每遍呈现之后回调)}*/
		ignore: [],		// 需排除的id
		summary: false,
		groupField: null		// 默认分组字段
	},
	// _group: { flex, key, minWidth, maxWidth, margin, padding: '5px 0px 5px 0px', layout: { type: 'hbox', pack: 'start', wrap: true }, },
	_group: {
		...fldCommProps, editable: undefined, labelAlign: 'top', margin: '0px 0px 0px 20px', padding: null, layout: null, height: null, initHeight: 43,
		scrollable: false, delay: false,
		// contextmenu: null
	},
	_int: {
		...fldCommProps, value, decimals: 0, minValue: null, maxValue: null, stepValue: null, cycle: false, textAlign: 'right', clearable: false,
		thousandsSeperator: true
	},
	_label: { flex, key, label, minWidth: null, maxWidth, margin, width: null, padding: '5px 0px 5px 0px', style: null, align: 'left', noLocale: false },
	_lineProcessing: { ...fldCommProps },
	_lineProcessing2: { ...fldCommProps, styles: null },
	_livescan: { ...fldCommProps, value },
	_month: { ...fldCommProps, min: null, max: null, value },
	_multiSelect: {
		...fldCommProps, value, options: null,
		locale: false,
		editable: undefined
	},
	_need2know: { ...fldCommProps, desc: '须知', title: null, content: '', delay: 0, errorTarget },
	_number: {
		...fldCommProps, value, decimals: 2, minValue: null, maxValue: null, stepValue: null, cycle: false, textAlign: 'left',
		trim: true, clearable: false, thousandsSeperator: true
	},
	_pdf: {
		minWidth, maxWidth, /* width: '100%',  */flex, padding: '5px 0px 5px 20px', layout: { type: 'hbox', pack: 'start', wrap: true },
		margin, height: null,	// pnlProps
		value,
		FID: null, printable: false, downloadable: false,
		commentsEnabled: false, commentsEditable: false, showCommentsPanel: null, stamp: null
	},
	_pdfStamp: {
		minWidth, maxWidth, /* width: '100%',  */flex, padding: '5px 0px 5px 20px', layout: { type: 'hbox', pack: 'start', wrap: true },
		margin, height: null,	// pnlProps
		value, FID: null, stamp: null/*置于key中，用于重新生成React结点*/, stamps: null/*印章数组*/
	},
	_radio: { ...fldCommProps, required: true, layout: { type: 'hbox', pack: 'start', wrap: true } },
	_radioItem: { itemNoLocale: true, disabled, key, itemMinWidth: 10, bodyAlign: 'start', boxLabelAlign: 'after', itemMargin: '0px 10px 0px 0px', },
	_resourceCalendar: {
		minWidth, maxWidth, width: '100%', flex, padding: '5px 0px 5px 20px', layout: { type: 'hbox', pack: 'start', wrap: true },
		margin, height: null
	},
	_scan: { ...fldCommProps, value },
	_schedule: {
		minWidth, maxWidth, width: '100%', flex, padding: '5px 0px 5px 20px', layout: { type: 'hbox', pack: 'start', wrap: true },
		margin, height: null
	},
	_segmentedButton: {
		key, margin, width: '100%',
		layout: { type: 'hbox', pack: 'start', align: 'center' },
		top: null, right: null, bottom: null, left: null,
		items: [], // 形始['text1', 'text2']或[['text1', 'vaue1'], ['text2', 'value2']]
		handler: null, // 未配置则调用onChange改为changedValues中的对应值
		selected: null,// 未配置则使用value
		value
	},
	_select: {
		...fldCommProps,
		value, editable: false, forceSelection: true, anyMatch: true, multiSelect: false, options: [],
		addInitValue: true,		// 是否将初始值加入到备选项中
		locale: false
	},
	// _selfdefine: { label, value, key, minWidth, maxWidth, disabled, flex, labelWidth, labelTextAlign, labelAlign, margin },
	_signature: {
		...fldCommProps, value, isReadOnly: false, disabled: false, maxStrokeWidth: 3.0, minStrokeWidth: 0.5,
		editable: undefined, clearable: undefined, noLocale: undefined,
	},
	_spreadsheet: {
		minWidth, maxWidth, width: '100%', flex, padding: '5px 0px 5px 20px', layout: { type: 'hbox', pack: 'start', wrap: true }, margin,
		height: null,	// pnlProps
		value, columns: null
	},
	_text: {
		...fldCommProps, value, maxRows: null, richtext: false, fontSize: '13px', richeditable: true,
		password: false, passwordShowable: true, passwordSavable: false, autoResize: false, resizable: true, maxLength: null, monospace: null
	},
	_treegrid: {
		minWidth, maxWidth, width: '100%', flex, padding: '5px 0px 5px 20px', layout: { type: 'hbox', pack: 'start', wrap: true }, margin,
		defaultIcon: null, defaultExpand: true
	},
	_treegridselect: {
		minWidth, maxWidth, width: '100%', flex, padding: '5px 0px 5px 20px', layout: { type: 'hbox', pack: 'start', wrap: true },
		margin, height: null,	// pnlProps
		columns: [], valueFields: [], sumFields: [], idField: 'id', parentIdField: 'parentID', frozenColumns: 0,
		defaultExpand: false,
	},
	_treeselect: {
		...fldCommProps, value,	/* valueField: 'id', */ displayField: 'text', displayFull: false, displayName: '',
		fullNameField: '', groupField: 'fatherID', leafOnly: false, options: null, rootText: '', title: ''
	},
	_treeselect2: {
		...fldCommProps, value,	/* valueField: 'id', */
		displayField: 'text', displayFull: false,
		displayName: '',
		fullNameField: '', groupField: 'fatherID',
		leafOnly: false, options: null, rootText: '',
		multiSelect: false,
		expanded: true,		// 默认是否展开: true/false/null: null不处理
	},
	_virtualGroup: { disabled },
}

// return { props: {}, encloserProps: {}, wrapperProps: {}, rest: {} }
export const getMixedProps = (() => {
	const encloserProps = ['minWidth', 'maxWidth', 'minHeight', 'width', 'flex']
	const wrapperProps = ['ui', 'labelAlign', 'labelTextAlign', 'labelWidth', 'labelMinWidth', 'margin', 'prompt']
	const wrapperSharedProps = ['label', 'disabled', 'required', 'noLocale']

	return (type, objs) => {
		let ret = objs.reduce((mixedStyle, obj) => Object.keys(obj).reduce((style, styleName) => {
			obj[styleName] !== undefined && ((style.props[styleName] !== undefined ? style.props : style.rest)[styleName] = obj[styleName])
			return style
		}, mixedStyle), { props: { ...defaultStyles[type] }, encloserProps: {}, wrapperProps: {}, rest: {} })

		// if (forContainer) {
		// 	ret = ret.props
		// 	Object.keys(ret).forEach(prop => !encloserProps.includes(prop) && delete ret[prop])
		// 	return ret
		// }

		// !(['Item', 'grid', 'button'/* , 'file', 'group', 'lineProcessing', 'captcha' */].find(o => name.includes(o)))
		!(noEncloserTypes.find(o => type.includes(o)))
			&& Object.entries({ ...ret.rest, ...ret.props })
				.forEach(([key, value]) => encloserProps.includes(key) && (ret.encloserProps[key] = value, delete ret.props[key]))

		// encloser的layout处理
		const { encloserLayout } = ret.rest
		encloserLayout && (ret.encloserProps.layout = typeof encloserLayout === 'string' ? { type: encloserLayout } : { ...encloserLayout })

		ret.rest._full && (ret.props.flex = 1)
		labelNeededTypes.includes(type) && Object.entries(ret.props).forEach(([key, value]) =>
			wrapperProps.includes(key)
				? (ret.wrapperProps[key] = value, delete ret.props[key])
				: wrapperSharedProps.includes(key) && (ret.wrapperProps[key] = value)
		)

		return ret
	}
})()

export const useDelayHandleChange = (handleChange, timeout = 200) => {
	const { doDelay, stopDelay } = useDelayTimer(timeout)
	const { current: me, current: { delayHandleChange } } = useRef({
		delayHandleChange: (...args) => {
			// const [, newValue] = args
			/* newValue == me.value ? stopDelay() :  */doDelay(() => me.handleChange(...args))
		}
	})

	// me.value = value
	me.handleChange = handleChange

	return delayHandleChange
}

